export const SOL_PASSWORD_ATTRIBUTE_CHANGE = 'SOL_PASSWORD_ATTRIBUTE_CHANGE';
